import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  output,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { EllipsisDirective } from '../../../directives/ellipsis/ellipsis';
import { HighlightsService } from '../../../services/selections/highlights';

/** Information-only view of the note of a highlight opened via someone else's shared link. */
@Component({
  selector: 'nr-shared-note-dialog',
  imports: [TranslatePipe, EllipsisDirective],
  templateUrl: './shared-note-dialog.html',
  styleUrl: '../notes.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedNoteDialogComponent {
  private readonly highlightsService = inject(HighlightsService);

  readonly note = this.highlightsService.noteToEdit;
  readonly colorMap = this.highlightsService.colorMap;

  readonly dialogClosed = output();
}
